module.exports = __webpack_public_path__ + "img/concatmap.1f54cd0e.jpg";